export const inlineActionConfirmationState = {
  FREE: 'free',
  CONFIRM: 'confirm',
} as const

export type InlineActionConfirmationState =
  typeof inlineActionConfirmationState[keyof typeof inlineActionConfirmationState]
